<template>
    <div ref="container">
      <a-modal :title="title" :width="1000" :visible="visible" :confirmLoading="confirmLoading" :getContainer="() => $refs.container" :maskStyle="{'top':'93px','left':'154px'}" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height: 50%;">
        <template slot="footer">
          <a-button key="back" @click="handleCancel">
            关闭
          </a-button>
          <a-button type="primary" @click="handleOk">
            确认
          </a-button>
        </template>
        <a-spin :spinning="confirmLoading">
          <a-form-model ref="form" :model="form" :rules="rules">
            <a-row class="form-row" :gutter="24">
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工序名称" prop="proceName">
                  <a-input placeholder="请输入工序名称" v-model="form.proceName" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工序编码" prop="proceCode">
                  <a-input placeholder="请输入工序编码" v-model="form.proceCode" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工序序号" prop="seq">
                  <a-input placeholder="请输入工序序号" v-model="form.seq" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <!-- 上传文件 -->
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="图片">
                  <a-upload
                    name="file"
                    listType="picture-card"
                    :multiple="isMultiple"
                    :action="uploadAction"
                    :headers="headers"
                    :data="{biz:bizPath}"
                    :fileList="fileList"
                    :beforeUpload="beforeUpload"
                    :disabled="disabled"
                    :isMultiple="isMultiple"
                    :showUploadList="isMultiple"
                    @change="handleChange"
                    @preview="handlePreview">
                    <img v-if="!isMultiple" :src="getAvatarView()" style="height:104px;max-width:300px"/>
                    <div v-else >
                      <a-icon :type="uploadLoading ? 'loading' : 'plus'" />
                      <div class="ant-upload-text">{{ text }}</div>
                    </div>
                    <a-modal :visible="previewVisible" :width="1000" :footer="null" @cancel="handledelete()">
                      <img alt="example" style="width: 100%" :src="previewImage"/>
                    </a-modal>
                  </a-upload>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </a-spin>
      </a-modal>
    </div>
  </template>
  <script>
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import pick from 'lodash.pick'
  import { addProcess, updateProcess, uploadFiles } from '@/api/api'
  import { autoJumpNextInput } from '@/utils/util'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import Vue from 'vue'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  import axios from 'axios'
  export default {
    name: 'VendorModal',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      JImageUpload,
    },
    data() {
      return {
        title: '操作',
        visible: false,
        fileList: [],
        model: {},
        isReadOnly: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
        confirmLoading: false,
        form: {
            proceName: '',
            proceCode: '',
        },
        uploadHeaders: {
          authorization: 'authorization-text',
        },
        // uploadHeaders: {},
        uploadAction: window._CONFIG['domianURL'] + '/htmlTemplate/uploadFiles',
        rules: {
          proceName: [{ required: true, message: '工序名称不可为空!' }],
          proceCode: [{ required: true, message: '工序编码不可为空!' }],
        },
        id: '',
        uploadUrl: ''
      }
    },
    created() {},
    methods: {
      add() {
        this.edit({})
      },
      edit(record) {
        if (this.$refs.form !== undefined) {
          this.$refs.form.resetFields(); // 尝试重置表单字段
        }
        // 手动重置表单数据
        this.form = {
          proceName: '', // 初始化表单字段
          proceCode: '', // 初始化表单字段
          seq: '', // 工序序号
          fileName: '',
          fileList: []
        };
        if (record.id) {
          this.form = { ...record }; // 使用对象展开运算符复制对象
          console.log(this.form,'form=========================')
          this.fileList.push({url:record.fileName})
          this.id = record.id
        } else {
          this.fileList = []
        }
        this.visible = true
        this.$nextTick(() => {})
      },
      // handleChange({ file, fileList }) {
      //   console.log(file,fileList, 'file')
      // },
      handlePreview(){},
      handleDelete() {
        this.close();
        this.previewVisible = false;
      },
      handleChange(info) {
        console.log("--文件列表改变--")
        if(!info.file.status && this.uploadGoOn === false){
          info.fileList.pop();
        }
        this.picUrl = false;
        let fileList = info.fileList
        if(info.file.status==='done'){
          if(info.file.response.code === 200){
            this.$message.success(info.file.name + info.file.response.message)
            this.uploadUrl =  process.env.VUE_APP_UPLOAD_URL + '/download/h5template/' + info.file.response.result
            this.picUrl = true;
            fileList = fileList.map((file) => {
              if (file.response) {
                file.url = file.response.data;
              }
              return file;
            });
          }
        }else if (info.file.status === 'error') {
          this.$message.error(`${info.file.name} 上传失败.`);
        }else if(info.file.status === 'removed'){
          this.handleDelete(info.file)
        }
        this.fileList = fileList
        if(info.file.status==='done' || info.file.status === 'removed'){
          this.handlePathChange()
        }
      },
      getAvatarView(){
        if(this.fileList.length>0){
          let url = this.fileList[0].url
          return url
        }
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleOk() {
        const that = this
        // 触发表单验证
        that.$refs['form'].validate(async (success) => {
          if (success === true) {
            let params = {
                proceName: this.form.proceName,
                proceCode: this.form.proceCode,
                seq: this.form.seq,
                fileName: this.uploadUrl,
                segmentType : 1, // 1工艺2流通
            }
            if (this.id) {
              // 编辑
              params.id = this.id
              const res = await updateProcess(params)
              console.log(res, 'res')
              if (res.code == 200 && res.success == true) {
                this.$message.success(res.result)
                this.close()
                this.form.craftCode = ''
                this.form.craftName = ''
                this.id = ''
                this.fileList = []
                this.$emit('ok')
              } else {
                this.$message.error(res.result)
              }
            } else {
              const res = await addProcess(params)
              console.log(res, 'res')
              if (res.code == 200 && res.success == true) {
                this.form.craftCode = ''
                this.form.craftName = ''
                this.fileList = []
                this.$message.success(res.result)
                this.$emit('ok')
                this.close()
              } else {
                this.$message.error(res.result)
              }
            }
          }
        })
      },
       // 上传前的检查
      beforeUpload(file) {
        return true;
      },
      handleCancel() {
        this.close()
        this.fileList = []
      },
      validateSupplierName(rule, value, callback) {
        let params = {
          name: value,
          type: '供应商',
          id: this.model.id ? this.model.id : 0,
        }
        checkSupplier(params).then((res) => {
          if (res && res.code === 200) {
            if (!res.data.status) {
              callback()
            } else {
              callback('名称已经存在')
            }
          } else {
            callback(res.data)
          }
        })
      },
    },
  }
  </script>
  <style scoped>
  </style>